import React from 'react';
import { IfProps } from './If.types';

export const If: React.FC<IfProps> = ({ condition, children }) =>
    condition ? <>{children}</> : null;

If.displayName = 'If';
